import { useEffect } from 'react';

import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';
import DatePicker from '@/components/DatePicker';
import useWorkflowLogsFilters from '@/components/modals/workflowLogsModal/lib/useWorkflowLogsFilters';

const DateRangeFilter = () => {
  const workflowIdParam = useArgSelector(selectors.param, 'workflowId');
  const workflowIdQuery = useArgSelector(selectors.query, 'workflowId');

  const workflowId = workflowIdParam || workflowIdQuery;
  const dateRange = useArgSelector(selectors.pref, `workflowLogsDateRangeFilter-${workflowId}`);
  const { handleFilterChange } = useWorkflowLogsFilters();

  useEffect(() => {
    if (workflowId && dateRange === undefined) {
      handleFilterChange('dateRange', { action: 'last24Hours' });
    }
  }, [workflowId, dateRange, handleFilterChange]);

  const hasDateRange = dateRange !== undefined;

  const handleDateChange = (date) => {
    const timeFilter = date?._timeFilter || null;

    if (date?.action || date?._action) {
      const action = date.action || date._action;

      handleFilterChange('dateRange', { action, _timeFilter: timeFilter });
      return;
    }

    if (!date || (Array.isArray(date) && date?.length === 0)) {
      handleFilterChange('dateRange', { from: null, to: null, _timeFilter: timeFilter });
      return;
    }

    const data = {
      from: date?.[0],
      to: date?.length === 1 ? date?.[0] : date?.[date?.length - 1],
      _timeFilter: timeFilter
    };

    handleFilterChange('dateRange', data);
  };

  const getInitialValue = () => {
    if (dateRange) return dateRange;

    return { action: 'last24Hours' };
  };

  return (
    <DatePicker //
      container={document.querySelector('.workflow-logs-modal')}
      variant={`outline filter date-range-filter ${hasDateRange ? 'active' : ''}`}
      size="sm"
      initialValue={getInitialValue()}
      onChange={handleDateChange}
      showTimeRanges
    />
  );
};

export default DateRangeFilter;
